import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';

export function trackRecipesClickSelectYourOwnPlan() {
  track(segmentTrackEvents.recipes_click_select_your_own_plan);
}
